import * as React from "react";
import Layout from "../../components/Layout";
import Header from "./Header";
import LatestPosts from "./LatestPosts";
import {useTranslation} from "react-i18next";
import {Post} from "../../types/Post";

interface HomeViewProps {
	posts: {
		node: Post,
	}[];
}

const HomeView: React.FC<HomeViewProps> = (props) => {
	const {t} = useTranslation();
	return (
		<Layout title={t('Home')}>
			<Header/>
			<LatestPosts
				posts={props.posts}
			/>
		</Layout>
	);
};

export default HomeView;
